function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var defaultState = {
  count: 0,
  data: [],
  selectedContacts: [],
  haveNext: false,
  havePrevious: false,
  limit: 0,
  total: 0,
  tableState: {
    currentPage: 1,
    wildcard: "",
    orderBy: null,
    orderByDesc: null
  },
  users: []
};
export default (function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case "GET_CONTACTS_LIST":
      return _objectSpread(_objectSpread({}, state), action.list);

    case "CREATE_CONTACT":
      return state;

    case "UPDATE_CONTACT":
      return state;

    case "DELETE_CONTACT":
      return state;

    case "SELECT_CONTACT":
      return _objectSpread(_objectSpread({}, state), {}, {
        selectedContacts: state.selectedContacts.find(function (c) {
          return c.id == action.contact.id;
        }) ? state.selectedContacts.filter(function (c) {
          return c.id != action.contact.id;
        }) : [].concat(_toConsumableArray(state.selectedContacts), [action.contact])
      });

    case "SELECT_CONTACTS":
      {
        var contactsToToggle = state.data;
        var result = state.selectedContacts;

        var _iterator = _createForOfIteratorHelper(contactsToToggle),
            _step;

        try {
          var _loop = function _loop() {
            var contactToToggle = _step.value;

            if (action.value && !result.map(function (c) {
              return c.id;
            }).includes(contactToToggle.id)) {
              result = [].concat(_toConsumableArray(result), [contactToToggle]);
            }

            if (!action.value) {
              result = result.filter(function (c) {
                return c.id != contactToToggle.id;
              });
            }
          };

          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            _loop();
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }

        return _objectSpread(_objectSpread({}, state), {}, {
          selectedContacts: result
        });
      }

    case "DESELECT_CONTACTS":
      return _objectSpread(_objectSpread({}, state), {}, {
        selectedContacts: []
      });

    case "SET_TABLE_STATE":
      return _objectSpread(_objectSpread({}, state), {}, {
        tableState: action.tableState
      });

    case "GET_CONTACTS_USERS":
      return _objectSpread(_objectSpread({}, state), {}, {
        users: action.users
      });

    default:
      return state;
  }
});